import { GenericValue } from '../generic-value.model';

export class AttributeSmartValue {
  AttributeTemplatePath: string;
  ElementPath: string;
  RootElementVersionID: number;
  ElementVersionID?: number;
  AttributeID: number;
  Value: GenericValue;
  ValueTypeID: number;
  isChanged: boolean;
  ChildElementPath?: string;
  TimeStamp?: Date;
  AttributeTemplateName?: string;
  isAutoSave?: boolean;
}
